import { render, staticRenderFns } from "./disease_science.vue?vue&type=template&id=49eeb3e7&"
import script from "./disease_science.vue?vue&type=script&lang=js&"
export * from "./disease_science.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports